// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"BackupBulkActions_bulkActions-2y4aK"};